// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dispatchGAEvents = (data: any) => {
    // window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push(data);

    window.dataLayer = window.dataLayer || [];

    const existingEventIndex = window.dataLayer.findIndex(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => item.event === data.event
    );

    if (existingEventIndex !== -1) {
        // Replace the existing event object with the new one
        window.dataLayer[existingEventIndex] = data;
    } else {
        // Add the new event object to the dataLayer
        window.dataLayer.push(data);
    }
};
